import React from "react";
import styles from "./Loading.module.css";

function Loading() {
    return (
        <div className={styles.area}>
            <div className={styles.spinner}>
                <div className={styles.dot1}></div>
                <div className={styles.dot2}></div>
            </div>
        </div>
    );
}

export default Loading;